import { NavLink } from 'react-router-dom';
import { styled } from 'styled-components';

export const SidebarContainer = styled.div`
  display: flex;
  position: fixed;
  left: 0;
  top: 0;
  min-width: 235px;
  height: 100dvh;
  padding: 32px 16px;
  flex-direction: column;
  justify-content: space-between;

  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.15);
  @media (max-width: 800px) {
    display: none;
  }
`;

export const NavContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Tabs = styled.div`
  display: flex;
  flex-direction: column;
  gap: 50px;
`;
export const LogoutContainer = styled.div`
  width: 100%;
  display: flex;
  cursor: pointer;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  justify-content: flex-start;
  padding-left: 12px;
`;

export const Text = styled.span`
  font-family: 'Poppins-Regular';

  font-size: 14px;
  user-select: none;

  letter-spacing: -0.408px;
`;

export const StyledNavLink = styled(NavLink)`
  display: flex;
  user-select: none;
  opacity: 0.4;
  align-items: center;

  border-radius: 12px;
  background-color: transparent;
  color: black;
  padding: 12px 20px 12px 16px;
  text-decoration: none;
  font-family: 'Poppins-Medium';

  font-size: 14px;
  letter-spacing: -0.4px;
  gap: 8px;

  transition: all 0.2s ease-in-out;

  &.active {
    opacity: 1;
    background-color: #f5edef;
  }

  &.active:hover {
    scale: 1;
  }
  &:hover {
    scale: 1.05;
  }
`;

export const Dot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background-color: red;
  margin-right: 15px;
`;
